module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-left p-l-10 p-r-10-p"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-control b-0 p-0"
  }, [_vm._v("訂單明細")]), _vm._v(" "), _c('div', {
    staticClass: "order-list-box m-x-0"
  }, _vm._l((_vm.productList), function(p, index) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(p.product))]), _vm._v(" "), _c('p', [_vm._l((p.option_list), function(option) {
      return _c('span', [_vm._v(_vm._s(option) + " / ")])
    }), _vm._v(" " + _vm._s(p.total_money) + "元 / " + _vm._s(p.amount) + "杯")], 2), _vm._v(" "), (_vm.productList.length !== index + 1) ? _c('hr') : _vm._e()])
  }), 0), _vm._v(" "), _c('br')])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fadb450"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/History/HistoryOrderInfo.vue
// module id = 2416
// module chunks = 1